'use client';

import { Button } from '@mantine/core';
import { useCart } from '@/contexts/cartContext';
import { useState } from "react";
export default function ProductCardAddToCartButton({
  product
}) {
  const {
    addToCart,
    cartLoading
  } = useCart();
  const [isAdding, setIsAdding] = useState(false);
  const defaultVariant = product?.variants?.[0];
  const handleAdd = async () => {
    if (cartLoading) return; // global guard: cart context is already mid-request
    setIsAdding(true);
    try {
      await addToCart({
        product_id: product.product_id,
        variant_id: defaultVariant?.variant_id,
        quantity: 1
      });
    } finally {
      setIsAdding(false);
    }
  };
  return <Button tt={'uppercase'} fullWidth loading={isAdding} disabled={cartLoading && !isAdding} onClick={handleAdd}>
            Add To Cart
        </Button>;
}